import { render, staticRenderFns } from "./comp-content-section-cell-v2.vue?vue&type=template&id=25638e7c&"
import script from "./comp-content-section-cell-v2.vue?vue&type=script&lang=ts&"
export * from "./comp-content-section-cell-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports